import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('../views/Home.vue'),
    redirect: '/award/index',
    children:[
      {
        path: 'registration_system',
        name: 'RegistrationSystem',
        component: () => import('../views/registration/Home.vue'),
        redirect: '/registration_system/login/declaration',
        children: [
          {
            path: 'login',
            name: 'Login',
            component: () => import('../views/registration/login/Home.vue'),
            redirect: '/registration_system/login/declaration',
            children: [
              {
                path: 'declaration',
                name: 'LoginDeclaration',
                component: () => import('../views/registration/login/Declaration.vue'),
              },
              {
                path: 'review',
                name: 'LoginReview',
                component: () => import('../views/registration/login/Review.vue'),
              },
              {
                path: 'admin',
                name: 'LoginAdmin',
                component: () => import('../views/registration/login/Admin.vue'),
              }
            ]
          },
          {
            path: 'register',
            name: 'Register',
            component: () => import('../views/registration/Register.vue'),
          },
          {
            path: 'reset_password',
            name: 'ResetPwd',
            component: () => import('../views/registration/ResetPwd.vue'),
          }
        ]
      },
      {
        path: 'declaration_system',
        name: 'DeclarationSystem',
        component: () => import('../views/declaration/Home.vue'),
        redirect: '/declaration_system/company_information',
        children: [
          {
            path: 'company_information',
            name: 'CompanyInformation',
            component: () => import('../views/declaration/CompanyInformation.vue'),
          },
          {
            path: 'project_information',
            name: 'ProjectInformation',
            component: () => import('../views/declaration/ProjectInformation.vue'),
          },
          {
            path: 'data_download',
            name: 'DataDownload',
            component: () => import('../views/declaration/DataDownload.vue'),
          }
        ]
      },
      {
        path: 'award',
        name: 'Award',
        component: () => import('../views/award/Home.vue'),
        redirect: '/award/index',
        children: [
          {
            path: 'index',
            name: 'AwardIndex',
            component: () => import('../views/award/Index.vue')
          },
          {
            path: 'about',
            name: 'AwardAbout',
            component: () => import('../views/award/about/Home.vue'),
            redirect: '/award/about/introduction',
            children: [
              {
                path: 'introduction',
                name: 'AwardIntroduction',
                component: () => import('../views/award/about/Introduction.vue')
              },
              {
                path: 'note',
                name: 'AwardNote',
                component: () => import('../views/award/about/Note.vue')
              },
              {
                path: 'rules',
                name: 'AwardRules',
                component: () => import('../views/award/about/Rules.vue')
              },
              {
                path: 'expert',
                name: 'AwardExpert',
                component: () => import('../views/award/about/Expert.vue'),
              }
            ]
          },
          {
            path: 'review',
            name: 'AwardReview',
            component: () => import('../views/award/Review.vue')
          },
          {
            path: 'news_details',
            name: 'NewsDetails',
            component: () => import('../views/award/news/Details.vue')
          },
          {
            path: 'news_info_1',
            name: 'AwardNewsInfo1',
            component: () => import('../views/award/news/NewsInfo1.vue')
          },
          {
            path: 'news_info_2',
            name: 'AwardNewsInfo2',
            component: () => import('../views/award/news/NewsInfo2.vue')
          },
          {
            path: 'news_info_3',
            name: 'AwardNewsInfo3',
            component: () => import('../views/award/news/NewsInfo3.vue')
          },
          {
            path: 'news_info_4',
            name: 'AwardNewsInfo4',
            component: () => import('../views/award/news/NewsInfo4.vue')
          },
          {
            path: 'project',
            name: 'AwardProject',
            component: () => import('../views/award/Project.vue')
          }
        ]
      },
      {
        path: 'admin_system',
        name: 'AdminSystem',
        component: () => import('../views/admin/Home.vue'),
        redirect: '/admin_system/check_basic',
        children: [
          {
            path: 'check_basic',
            name: 'AdminCheckBasic',
            meta: {
              keepAlive: true,
              footerHidden: true
            },
            component: () =>
              import ('../views/admin/check/Basic.vue')
          }, {
            path: 'basic_info',
            name: 'AdminBasicInfo',
            meta: {
              footerHidden: true
            },
            component: () =>
              import ('../views/admin/check/BasicInfo.vue')
          }, {
            path: 'check_project',
            name: 'AdminCheckProject',
            meta: {
              keepAlive: true,
              footerHidden: true
            },
            component: () =>
              import ('../views/admin/check/Project.vue')
          }, {
            path: 'project_info',
            name: 'AdminProjectInfo',
            meta: {
              footerHidden: true
            },
            component: () =>
              import ('../views/admin/check/ProjectInfo.vue')
          }, {
            path: 'preliminary_distribution',
            name: 'AdminPreliminaryDistribution',
            meta: {
              footerHidden: true
            },
            component: () =>
              import ('../views/admin/result/PreliminaryDistribution.vue')
          }, {
            path: 'preliminary_result',
            name: 'AdminPreliminaryResult',
            meta: {
              footerHidden: true
            },
            component: () =>
              import ('../views/admin/result/Preliminary.vue')
          }, {
            path: 'final_distribution',
            name: 'AdminFinalDistribution',
            meta: {
              footerHidden: true
            },
            component: () =>
              import ('../views/admin/result/FinalDistribution.vue')
          }, {
            path: 'final_result',
            name: 'AdminFinalResult',
            meta: {
              footerHidden: true
            },
            component: () =>
              import ('../views/admin/result/Final.vue')
          }, {
            path: 'publish_result',
            name: 'AdminPublishResult',
            meta: {
              footerHidden: true
            },
            component: () =>
              import ('../views/admin/result/Publish.vue')
          }, {
            path: 'distribution_result',
            name: 'AdminDistributionResult',
            meta: {
              footerHidden: true
            },
            component: () =>
              import ('../views/admin/result/DistributionResult.vue')
          }, {
            path: 'judge_list',
            name: 'AdminJudgeList',
            meta: {
              footerHidden: true
            },
            component: () =>
              import ('../views/admin/judge/List.vue')
          }, {
            path: 'user_list',
            name: 'AdminUserList',
            meta: {
              footerHidden: true
            },
            component: () =>
              import ('../views/admin/info/UserList.vue')
          }, {
            path: 'set_date',
            name: 'AdminSetDate',
            meta: {
              footerHidden: true
            },
            component: () =>
              import ('../views/admin/info/SetEndDate.vue')
          }, {
            path: 'distribution',
            name: 'AdminDistribution',
            meta: {
              footerHidden: true
            },
            component: () =>
              import ('../views/admin/info/Distribution.vue'),
            redirect: '/admin_system/distribution/result',
            children: [{
              path: 'result',
              name: 'AdminResult',
              meta: {
                footerHidden: true
              },
              component: () =>
                import ('../views/admin/result/DistributionResult.vue')
            }]
          }, {
            path: 'export',
            name: 'AdminExport',
            meta: {
              footerHidden: true
            },
            component: () =>
              import ('../views/admin/export/Index.vue'),
            redirect: '/admin_system/export/basic',
            children: [{
              path: 'basic',
              name: 'AdminExportBasic',
              meta: {
                footerHidden: true
              },
              component: () =>
                import ('../views/admin/export/Basic.vue')
            }, {
              path: 'project',
              name: 'AdminExportProject',
              meta: {
                footerHidden: true
              },
              component: () =>
                import ('../views/admin/export/Project.vue')
            }, {
              path: 'result',
              name: 'AdminExportResult',
              meta: {
                footerHidden: true
              },
              component: () =>
                import ('../views/admin/export/Result.vue')
            }]
          },
          {
            path: 'news',
            name: 'AdminNews',
            meta: {
              footerHidden: true
            },
            component: () => import('../views/admin/website/news/Index.vue'),
            redirect: '/admin_system/news/list',
            children: [
              {
                path: 'list',
                name: 'AdminNewsList',
                meta: {
                  footerHidden: true
                },
                component: () => import('../views/admin/website/news/List.vue')
              }, {
                path: 'info',
                name: 'AdminNewsInfo',
                meta: {
                  footerHidden: true
                },
                component: () => import('../views/admin/website/news/Info.vue')
              }
            ]
          },
          {
            path: 'ad',
            name: 'AdminAd',
            meta: {
              footerHidden: true
            },
            component: () => import('../views/admin/website/ad/Index.vue'),
            redirect: '/admin_system/ad/list',
            children: [
              {
                path: 'list',
                name: 'AdminAdList',
                meta: {
                  footerHidden: true
                },
                component: () => import('../views/admin/website/ad/List.vue')
              }, {
                path: 'info',
                name: 'AdminAdInfo',
                meta: {
                  footerHidden: true
                },
                component: () => import('../views/admin/website/ad/Info.vue')
              }
            ]
          },
          {
            path: 'video',
            name: 'AdminVideo',
            meta: {
              footerHidden: true
            },
            component: () => import('../views/admin/website/video/Index.vue'),
            redirect: '/admin_system/video/list',
            children: [
              {
                path: 'list',
                name: 'AdminVideoList',
                meta: {
                  footerHidden: true
                },
                component: () => import('../views/admin/website/video/List.vue')
              }, {
                path: 'info',
                name: 'AdminVideoInfo',
                meta: {
                  footerHidden: true
                },
                component: () => import('../views/admin/website/video/Info.vue')
              }
            ]
          },
          {
            path: 'expert',
            name: 'AdminExpert',
            meta: {
              footerHidden: true
            },
            component: () => import('../views/admin/website/expert/Index.vue'),
            redirect: '/admin_system/expert/list',
            children: [
              {
                path: 'list',
                name: 'AdminExpertList',
                meta: {
                  footerHidden: true
                },
                component: () => import('../views/admin/website/expert/List.vue')
              }, {
                path: 'info',
                name: 'AdminExpertInfo',
                meta: {
                  footerHidden: true
                },
                component: () => import('../views/admin/website/expert/Info.vue')
              }
            ]
          }
        ]
      },
      {
        path: 'review_system',
        name: 'ReviewSystem',
        component: () => import('../views/review/Home.vue'),
        redirect: '/review_system/list',
        children: [{
          path: 'list',
          name: 'ReviewList',
          meta: {keepAlive: true},
          component: () =>
            import ('../views/review/List.vue')
        }, {
          path: 'info',
          name: 'ReviewInfo',
          component: () =>
            import ('../views/review/Info.vue')
        }]
      }
    ]
  },
  {
    path: '/test',
    name: 'Test',
    component: () => import('../views/Test.vue')
  }
]

const router = new VueRouter({
  routes
})

export default router
